/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/scenario-mapper/scenario-asset',['require','backbone','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  //var $ = require('jquery');
  //var _ = require('underscore');
  //var templates = require('core/templates');
  var Backbone = require('backbone');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var ScenarioAsset = Marionette.Object.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    id: null,
    nlID: null,
    chatmapperID: null,
    saType: null,
    nodeColor: null,
    radio: Backbone.Wreqr.radio.channel('global').vent,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(data)
    {
      ////console.log('ScenarioAsset::initialize');
      this.parseData(data);
    },

    parseData: function(data)
    {
      ////console.log('Parse data', data);
      this.id = data.ID.toString();
      this.nlID = (data.nlID !== undefined) ? data.nlID : 'nl-' + data.ID.toString();
      this.chatmapperID = data.ID.toString();
    }

  /*****************************************************************************************************************///}

  });

  ScenarioAsset.SA_TYPE_ACTOR = 'SA_TYPE_ACTOR';
  ScenarioAsset.SA_TYPE_CONVERSATION = 'SA_TYPE_CONVERSATION';
  ScenarioAsset.SA_TYPE_ITEM = 'SA_TYPE_ITEM';
  ScenarioAsset.SA_TYPE_LOCATION = 'SA_TYPE_LOCATION';
  ScenarioAsset.SA_TYPE_VARIABLE = 'SA_TYPE_VARIABLE';
  ScenarioAsset.SA_TYPE_DIALOG = 'SA_TYPE_DIALOG';
  ScenarioAsset.SA_TYPE_LINK = 'SA_TYPE_LINK';

  return ScenarioAsset;

});

